"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardLayoutData = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var dataLoaders_1 = require("../../../dataLoaders");
var utils_1 = require("../utils");
/**
 * Hook allowing to download additional dashboard layout data (visualization classes and insights)
 * @param config - configuration of the hook
 * @beta
 * @deprecated Will be removed in the 8.10.0 release. Superseded by Dashboard component; please see `@gooddata/sdk-ui-dashboard` and GoodData.UI documentation for v8.7
 */
exports.useDashboardLayoutData = function (_a) {
    var dashboardLayout = _a.dashboardLayout, backend = _a.backend, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useDashboardLayoutData");
    utils_1.workspaceInvariant(effectiveWorkspace, "useDashboardLayoutData");
    var promise = dashboardLayout
        ? function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var insightRefsToLoad, loader, insights, getInsightByRef, getVisType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        insightRefsToLoad = sdk_backend_spi_1.layoutWidgets(dashboardLayout)
                            .filter(sdk_backend_spi_1.isInsightWidget)
                            .map(function (w) { return w.insight; });
                        loader = dataLoaders_1.insightDataLoaderFactory.forWorkspace(effectiveWorkspace);
                        return [4 /*yield*/, Promise.all(insightRefsToLoad.map(function (ref) { return loader.getInsight(effectiveBackend, ref); }))];
                    case 1:
                        insights = _a.sent();
                        getInsightByRef = function (insightRef) {
                            return insights.find(function (i) { return sdk_model_1.areObjRefsEqual(i.insight.ref, insightRef); });
                        };
                        getVisType = function (widget) {
                            if (widget.type === "kpi") {
                                return undefined;
                            }
                            var insight = getInsightByRef(widget.insight);
                            return sdk_model_1.insightVisualizationUrl(insight).split(":")[1];
                        };
                        return [2 /*return*/, {
                                getVisType: getVisType,
                                getInsightByRef: getInsightByRef,
                            }];
                }
            });
        }); }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        dashboardLayout,
    ]);
};
//# sourceMappingURL=useDashboardLayoutData.js.map